<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="chapter6">
<h1 class="left"><a id="page39"></a><a href="#/006toc#ch06">C<span class="small">HAPTER</span> Six</a></h1>
<p class="indent">If it turns blue, it’s positive.” The words seemed frightening to Tory as she stood facing her husband in the bedroom the next morning. The children were still sleeping. She had deliberately risen early with hopes of putting her fears to rest before breakfast.</p>
<p class="indent">Barry looked down at his watch. “Eight minutes left.”</p>
<p class="indent">“What if we get a false answer? How do we know we can trust this test?”</p>
<p class="indent">“I trust it,” he said. “They’re pretty accurate. It was right the last couple of times.”</p>
<p class="indent">“And what if it’s clear?” she asked, frowning. “I thought about it all night. A little baby.” Her eyes misted over, and she swallowed hard.</p>
<p class="indent">“If it’s clear, you’ll cry a little and go on.”</p>
<p class="indent">“And if it’s blue?”</p>
<p class="indent">He grinned. “You’ll cry a little and go on.”</p>
<p class="indent">“So it’s a lose-lose situation.”</p>
<p class="indent"><a id="page40"></a>“Win-win, is what I was thinking.”</p>
<p class="indent">“Okay, so that vial is either half full or half empty…with either clear or blue liquid.” She clutched her head with both hands. “Why am I so nervous?”</p>
<p class="indent">“Because you don’t know what you want. Decide if you want it to be blue or clear.”</p>
<p class="indent">“What do <i>you</i> want?” she asked.</p>
<p class="indent">He grinned. “Blue, I think.”</p>
<p class="indent">A matching grin tiptoed across her face. “I think I do, too.”</p>
<p class="indent">He looked at his watch again. “Five more minutes.”</p>
<p class="indent">“If it’s going to turn, do you think it would have turned a little by now?”</p>
<p class="indent">He got up. “I’m going to look.”</p>
<p class="indent">“No!” she said, grabbing his arm to stop him. “No, I don’t want to know.”</p>
<p class="indent">“Well, I do!”</p>
<p class="indent">“I changed my mind,” she said, as if her wishes could change the test’s results. “I want it to be clear.”</p>
<p class="indent">“Maybe it is.”</p>
<p class="indent">She fell back on the bed with a bounce. “No, I want blue.” She threw her hands over her face. “I don’t know.”</p>
<p class="indent">“You don’t have to make up your mind,” he said, laughing and bouncing down next to her. “It’s either blue or clear. Simple as that.” Rolling to his side, he grinned down at her. “This is kind of fun, isn’t it? In the next five minutes, we could be a family of five.”</p>
<p class="indent">“Or not.”</p>
<p class="indent">He checked his watch. “Two more minutes.”</p>
<p class="indent">She grinned. “One, two, three…”</p>
<p class="indent">Chuckling, he joined in, and they counted together. When they reached a hundred twenty, they both launched off the bed and headed for the bathroom, giggling and almost knocking each other down in the process.</p>
<p class="indent">Barry reached it first, but didn’t look. “Are you ready?”</p>
<p class="indent">“Show me,” she whispered, throwing her hands over her face.</p>
<p class="indent">She peaked through her fingers. He was grinning as he held up the vial. The bluest liquid she had ever seen seemed to glow <a id="page41"></a>from it like neon. Tears pushed into her eyes, and a gale of laughter almost blew her over. Barry started to laugh, too, and setting the vial down, pulled her into his arms. “We’re pregnant,” he said in a voice soft and high-pitched.</p>
<p class="indent">“We’re pregnant,” she agreed, shaking her head, unable to wipe the smile off her face.</p>
<p class="indent">“Will he be like Spencer, or like Britty?”</p>
<p class="indent">“<i>She’ll</i> be altogether different,” Tory said. “Not like either one of them. This baby will be one of a kind.”</p>
</div>
<p class="breakhere"></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 012-chapter6.vue?9b6341d8